import { defineAction } from '~/prix'
import { z } from 'zod'
import emergencyDispatchFetchAction from './emergencyDispatchFetch.action.json' with { type: 'json' }
import { emergencyDispatchObject } from '../emergencyDispatchObject'

const emergencyDispatchFetchDefinition = defineAction({
  ...emergencyDispatchFetchAction,

  input: z.object({
    id: z.string().uuid(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: emergencyDispatchObject,
})

export default emergencyDispatchFetchDefinition
